import { render } from "./PackageSpecCardToggling.vue?vue&type=template&id=33039eb7&scoped=true"
import script from "./PackageSpecCardToggling.vue?vue&type=script&lang=js"
export * from "./PackageSpecCardToggling.vue?vue&type=script&lang=js"

import "./PackageSpecCardToggling.vue?vue&type=style&index=0&id=33039eb7&lang=scss&scoped=true"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33039eb7"]])

export default __exports__